(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ona-module-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ona-module-catalog')){
 customElements.define('ona-module-catalog',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   const filters=this.querySelector('.ona-catalog__filters');if(!filters)return;
   const cards=Array.from(this.querySelectorAll('[data-category]'));
   const apply=(key)=>{let count=0;cards.forEach(card=>{card.hidden=key!=='all'&&card.dataset.category!==key;if(!card.hidden)count++;});filters.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===key)));this.querySelector('[data-count]').textContent=count;};
   const fromUrl=()=>{const key=new URL(window.location.href).searchParams.get('categorie');return Array.from(filters.querySelectorAll('[data-filter]')).some(b=>b.dataset.filter===key)?key:'all';};
   filters.hidden=false;apply(fromUrl());
   window.addEventListener('popstate',()=>apply(fromUrl()),{signal:this.abort.signal});
   filters.addEventListener('click',event=>{const b=event.target.closest('button[data-filter]');if(b&&filters.contains(b)){apply(b.dataset.filter);const url=new URL(window.location.href);if(b.dataset.filter==='all')url.searchParams.delete('categorie');else url.searchParams.set('categorie',b.dataset.filter);history.replaceState(null,'',url);}},{signal:this.abort.signal});
   this.addEventListener('shopify:block:select',()=>apply('all'),{signal:this.abort.signal});
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-physical-calendar"] && !Shopify.designMode) return;
  try {
    
function initOnaTrainerCalendar(){
 document.querySelectorAll('.ona-calendar').forEach(calendar=>{
 const requested=new URL(window.location.href).searchParams.get('trainer');
 const trainer=['ioana','magda'].includes(requested)?requested:'all';
 const name=trainer==='ioana'?'Ioana':'Magda';
 if(trainer!=='all')calendar.querySelector('[data-calendar-heading]').textContent='Cursuri fizice cu '+name;
 calendar.querySelectorAll('[data-trainer]').forEach(link=>{if(link.dataset.trainer===trainer)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
 calendar.querySelectorAll('[data-trainers]').forEach(card=>{
 card.hidden=trainer!=='all'&&!card.dataset.trainers.split(/\s+/).includes(trainer);
 card.querySelectorAll('.ona-calendar__dates p').forEach(row=>{const text=row.textContent.toLowerCase();row.hidden=trainer!=='all'&&(text.includes('ioana')||text.includes('magda'))&&!text.includes(trainer);});
 });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initOnaTrainerCalendar);else initOnaTrainerCalendar();
document.addEventListener('shopify:section:load',initOnaTrainerCalendar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-nail-coming-soon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ona-launch')) {
    customElements.define('ona-launch', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.interval);

        this.timer = this.querySelector('.ona-launch__timer');
        this.expired = this.querySelector('.ona-launch__expired');

        const date = (this.dataset.date || '').trim();
        const time = (this.dataset.time || '').trim();
        const offset = this.dataset.offset;
        const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
        const validTime = /^([01]\d|2[0-3]):[0-5]\d$/.test(time);
        let validDate = false;

        if (parts) {
          const d = new Date(
            Date.UTC(
              Number(parts[1]),
              Number(parts[2]) - 1,
              Number(parts[3])
            )
          );

          validDate =
            d.getUTCFullYear() === Number(parts[1]) &&
            d.getUTCMonth() === Number(parts[2]) - 1 &&
            d.getUTCDate() === Number(parts[3]);
        }

        this.target = Date.parse(date + 'T' + time + ':00' + offset);

        if (!validDate || !validTime || !Number.isFinite(this.target)) {
          this.timer.hidden = true;

          const warning = this.querySelector('.ona-launch__invalid');

          if (warning) warning.hidden = false;

          return;
        }

        const tick = () => {
          const remaining = Math.max(
            0,
            Math.ceil((this.target - Date.now()) / 1000)
          );

          const values = {
            days: Math.floor(remaining / 86400),
            hours: Math.floor(remaining / 3600) % 24,
            minutes: Math.floor(remaining / 60) % 60,
            seconds: remaining % 60
          };

          for (const [unit, value] of Object.entries(values)) {
            this.querySelector(
              '[data-unit="' + unit + '"]'
            ).textContent = String(value).padStart(2, '0');
          }

          this.timer.hidden = remaining === 0;
          this.expired.hidden =
            remaining > 0 || this.dataset.expiry === 'hide';

          if (!remaining) clearInterval(this.interval);
        };

        if (this.target > Date.now()) {
          this.interval = setInterval(tick, 1000);
        }

        tick();
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
